document.addEventListener("DOMContentLoaded", () => {
    const productRatings = document.querySelector('.questions-tab');
    
    function showRatings() {
        productRatings.style.visibility = 'visible';
    }
    
    const waitForNavBar = setInterval(function() {
        const navBar = document.querySelector('.oke-w-navBar');
        if (navBar) {
            clearInterval(waitForNavBar);
            setTimeout(showRatings, 2500);
            const questionsTab = document.querySelector('a.questions-tab');
            var tabButtons3 = document.querySelectorAll('div[role="tablist"] button');
            const contentElement = tabButtons3[1].querySelector('.oke-w-navBar-item-count');
            const content = contentElement ? contentElement.textContent : null;
            
            if (content !== null && typeof content !== 'undefined') {
                if (parseInt(content) === 1) {
                    questionsTab.innerHTML = content + ' Question';
                } else {
                    questionsTab.innerHTML = content + ' Questions';
                }
            } else {
                questionsTab.innerHTML = 'Ask a Question';
            }            
        }
    }, 200);
});

document.addEventListener("DOMContentLoaded", () => {
    const siteHeaderHeight = document.querySelector('.site-header').offsetHeight;
  const reviewLink = document.querySelector('.reviews-tab');
  const questLink = document.querySelector('.questions-tab');
  const scrollToElement = (element) => {
      if (element) {
        const scrollPosition = element.getBoundingClientRect().top + window.scrollY - siteHeaderHeight - 20;
        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
      }
  };

  reviewLink.addEventListener('click', () => {
      var tabButtons = document.querySelectorAll('div[role="tablist"] button');
      const firstButton = tabButtons[0];
      if (firstButton) {
          firstButton.click();
      }
      scrollToElement(document.getElementById('review-sections') || document.querySelector('.oke-w-navBar'));
  });

  questLink.addEventListener('click', () => {
      var tabButtons2 = document.querySelectorAll('div[role="tablist"] button');
      const secondButton = tabButtons2[1];
      if (secondButton) {
          secondButton.click();
      }
      scrollToElement(document.querySelector('.oke-w-navBar'));
  });
});

document.addEventListener("DOMContentLoaded", () => {

    function updateReviewStatus() {
        const countNumberElement = document.querySelector('.product-ratings .oke-sr-count-number');
        const starsElement = document.querySelector('.product-ratings .oke-sr-stars');
        const reviewTextElement = document.querySelector('.product-ratings .oke-sr-label-text');

        if (countNumberElement && starsElement && reviewTextElement) {
            clearInterval(interval);

            const ratingNumber = parseInt(countNumberElement.textContent.trim(), 10);

            if (ratingNumber === 0) {
                countNumberElement.style.display = 'none';
                starsElement.style.display = 'none';
                reviewTextElement.textContent = 'Leave a Review';
            }
            const productRatingsElement = document.querySelector('.product-ratings');

            setTimeout(() => {
                productRatingsElement.style.visibility = 'visible';
            }, 200);
        }
    }

    const interval = setInterval(updateReviewStatus, 1000);
});